import { PROGRAM_FEATUER_CHART_CONFIG } from '@constants/buzzkuri/program-detail'
import { useMemo } from 'react'

type Props = {
  communicationImpact: number
  teamImpact: number
  interactingPeopleImpact: number
  closenessImpact: number
  easinessImpact: number
}

export const useFeatureNumbersChart = (
  props: Props
): typeof PROGRAM_FEATUER_CHART_CONFIG => {
  const chartConfig = useMemo(() => {
    const {
      communicationImpact,
      teamImpact,
      interactingPeopleImpact,
      closenessImpact,
      easinessImpact,
    } = props
    PROGRAM_FEATUER_CHART_CONFIG.data.datasets[0].data = [
      communicationImpact,
      teamImpact,
      interactingPeopleImpact,
      closenessImpact,
      easinessImpact,
    ]
    return PROGRAM_FEATUER_CHART_CONFIG
  }, [props])

  return chartConfig
}
